import { useMemo } from 'react';
import { RenderIf } from 'react-rainbow-components';
import formatIntlPhoneNumber from 'data/services/phone/formatter';
import { Phonenumber } from 'data/firestore/agent/customer/phonenumber/types';
import Phone from 'components/icons/phone';
import Note from 'components/icons/note';
import {
    PhoneCellWrapper, Icon, Label, TooltipButton, TooltipContainer,
} from './styled';

interface Props {
    row?: Phonenumber;
    value?: string;
    emptyLabel?: string;
}

const PhoneColumn = ({ row, value = '', emptyLabel = '-' }: Props) => {
    const formattedNumber = useMemo(() => formatIntlPhoneNumber(value), [value]);
    const isEmpty = !value || value === '';
    if (isEmpty) {
        return (
            <PhoneCellWrapper>
                {emptyLabel || '-'}
            </PhoneCellWrapper>
        );
    }
    return (
        <PhoneCellWrapper>
            <Icon
                value={value}
                icon={<Phone />}
                primary={row?.type === 'primary'}
            />
            <Label>{formattedNumber}</Label>
            <RenderIf isTrue={row?.note}>
                <TooltipButton
                    icon={<Note />}
                    tooltip={(
                        <TooltipContainer>
                            <p>{row?.note}</p>
                        </TooltipContainer>
                    )}
                />
            </RenderIf>
        </PhoneCellWrapper>
    );
};

export default PhoneColumn;
